import useGetRewardTypes from './useGetRewardTypes'

export default useGetRewardTypes
